export default __webpack_public_path__ + "static/media/course1.0c21168e.png";